var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServMob3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 182,
    viewBox: "0 0 159 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 182,
    rx: 8,
    fill: "#F39E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0316 153H27.5596L28.8556 149.16H35.7676L37.0396 153H40.5916L34.4236 135.12H30.1996L24.0316 153ZM29.7916 146.28L32.3116 138.744L34.8316 146.28H29.7916ZM42.3175 157.8H45.4615V151.752C45.9415 152.248 46.5255 152.632 47.2135 152.904C47.9015 153.16 48.6455 153.288 49.4455 153.288C50.7095 153.288 51.8375 152.992 52.8295 152.4C53.8215 151.792 54.6055 150.976 55.1815 149.952C55.7575 148.912 56.0455 147.752 56.0455 146.472C56.0455 145.192 55.7575 144.04 55.1815 143.016C54.6055 141.976 53.8215 141.16 52.8295 140.568C51.8375 139.96 50.7175 139.656 49.4695 139.656C48.5735 139.656 47.7655 139.816 47.0455 140.136C46.3255 140.456 45.7335 140.904 45.2695 141.48V139.944H42.3175V157.8ZM49.0855 150.408C48.3975 150.408 47.7735 150.24 47.2135 149.904C46.6695 149.568 46.2375 149.104 45.9175 148.512C45.6135 147.92 45.4615 147.24 45.4615 146.472C45.4615 145.704 45.6135 145.024 45.9175 144.432C46.2375 143.84 46.6695 143.376 47.2135 143.04C47.7735 142.704 48.3975 142.536 49.0855 142.536C49.8055 142.536 50.4375 142.712 50.9815 143.064C51.5415 143.4 51.9815 143.864 52.3015 144.456C52.6215 145.048 52.7815 145.72 52.7815 146.472C52.7815 147.224 52.6215 147.904 52.3015 148.512C51.9815 149.104 51.5415 149.568 50.9815 149.904C50.4375 150.24 49.8055 150.408 49.0855 150.408ZM58.4425 157.8H61.5865V151.752C62.0665 152.248 62.6505 152.632 63.3385 152.904C64.0265 153.16 64.7705 153.288 65.5705 153.288C66.8345 153.288 67.9625 152.992 68.9545 152.4C69.9465 151.792 70.7305 150.976 71.3065 149.952C71.8825 148.912 72.1705 147.752 72.1705 146.472C72.1705 145.192 71.8825 144.04 71.3065 143.016C70.7305 141.976 69.9465 141.16 68.9545 140.568C67.9625 139.96 66.8425 139.656 65.5945 139.656C64.6985 139.656 63.8905 139.816 63.1705 140.136C62.4505 140.456 61.8585 140.904 61.3945 141.48V139.944H58.4425V157.8ZM65.2105 150.408C64.5225 150.408 63.8985 150.24 63.3385 149.904C62.7945 149.568 62.3625 149.104 62.0425 148.512C61.7385 147.92 61.5865 147.24 61.5865 146.472C61.5865 145.704 61.7385 145.024 62.0425 144.432C62.3625 143.84 62.7945 143.376 63.3385 143.04C63.8985 142.704 64.5225 142.536 65.2105 142.536C65.9305 142.536 66.5625 142.712 67.1065 143.064C67.6665 143.4 68.1065 143.864 68.4265 144.456C68.7465 145.048 68.9065 145.72 68.9065 146.472C68.9065 147.224 68.7465 147.904 68.4265 148.512C68.1065 149.104 67.6665 149.568 67.1065 149.904C66.5625 150.24 65.9305 150.408 65.2105 150.408ZM79.5355 153.288C80.5275 153.288 81.3915 153.12 82.1275 152.784C82.8635 152.448 83.4395 151.984 83.8555 151.392C84.2715 150.784 84.4795 150.088 84.4795 149.304C84.4795 148.392 84.1915 147.608 83.6155 146.952C83.0395 146.296 82.2075 145.816 81.1195 145.512L79.0315 144.888C78.5835 144.76 78.2155 144.592 77.9275 144.384C77.6395 144.176 77.4955 143.888 77.4955 143.52C77.4955 143.136 77.6475 142.824 77.9515 142.584C78.2555 142.344 78.6715 142.224 79.1995 142.224C79.8555 142.224 80.4475 142.4 80.9755 142.752C81.5195 143.104 81.8955 143.576 82.1035 144.168L84.5035 143.04C84.1035 141.984 83.4315 141.16 82.4875 140.568C81.5435 139.96 80.4555 139.656 79.2235 139.656C78.2795 139.656 77.4395 139.824 76.7035 140.16C75.9835 140.496 75.4155 140.968 74.9995 141.576C74.5995 142.168 74.3995 142.864 74.3995 143.664C74.3995 144.56 74.6795 145.336 75.2395 145.992C75.8155 146.648 76.6555 147.136 77.7595 147.456L79.8955 148.056C80.3115 148.168 80.6635 148.336 80.9515 148.56C81.2555 148.768 81.4075 149.056 81.4075 149.424C81.4075 149.856 81.2315 150.2 80.8795 150.456C80.5435 150.696 80.0955 150.816 79.5355 150.816C78.7995 150.816 78.1355 150.608 77.5435 150.192C76.9515 149.776 76.4795 149.2 76.1275 148.464L73.7755 149.592C74.1595 150.712 74.8635 151.608 75.8875 152.28C76.9275 152.952 78.1435 153.288 79.5355 153.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.8687,
    y: 56,
    width: 64,
    height: 32,
    rx: 16,
    fill: "#552049"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.869,
    cy: 72,
    r: 14,
    stroke: "#FFF7F0",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.8687,
    y: 38,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8687,
    y: 38,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.8687,
    y: 38,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.869 24L134.869 56V24H102.869Z",
    fill: "#755CDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.869,
    y: 38,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.869,
    y: 38,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.869,
    y: 38,
    width: 4,
    height: 4,
    fill: "#030303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 182,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServMob3);
export default __webpack_public_path__ + "static/media/serv_mob3.7bd0c6a1c066f816c5ac2db31371a4ed.svg";
export { ForwardRef as ReactComponent };